/*
 * ```
 *
 *  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .
 *     .       .       .       .       .       .       .       .       .       .       .       .
 *       . :SXt. .  :%X%. . ..%S%: . .    . .    .  .    .  .    .  .    .  .    .  .    .  .    .  . .
 *   .   .;8XSXt8 .S8@SX8@  888SS8t.    ..8  %t    .  .      .       .       .   ;X  X:      .
 *     . @%@:8;S8 t8%t8 X8.:88%8.X8X     ;8;:S; .       .  .   . ;;.   .  .    . t8.:X:.t..    .  . .  .
 *    .  8XXS tS8;X88S.SX8::8X; 8X8@ .  .:X;     . .  .   .      t@     .   .   .88    t;8   .   .
 *       8S88:@8@8888S X8888888.8X8@   . @ . . .  ...   .   .. . ;8  .    .   . .8S .  %8: .   .    . .
 *    . .8X88. ;8S%8;.  .8;:8%..8@8@   :S88.S@ ;t@::S S.  @;XttSS88;;;8;;   . %t:@8%:t X8; 8@% :; .
 *       8@@S  .  ...   .. .:. .8X8@ .   S;.:  X8    ;8X t8S     t8   .@;  .88; .8%. . @8.  :8 .8   . .
 *    . .8@@8;  .     .  .     .8X8@    .tX;  ;88.    X@ t8t     t8 .  88S t8@  :8S    @@%   t88.
 *       @@88:     .      .  . .8@8@  . .X .  :8: .  .@S t8@     S@.  . 88%8:.  .8S .  88:  X8%8S.  .  .
 *    .  8X88. .  .   . .   .  .8X8@     X : ..88t%;S@8X %8%  . .:8.     %88t  .:8S   .X8% S8S:X88:
 *      .8XXS    .   .         .8X8@ . ..88.    tXX SS%  :8t     @8. .  .888.   .@S .  tX: 88.. SS:  .
 *    .  8@88:.    .     . .  . 8X8@    .:. .    .: .  . ..  . .  .     S8%. .  .     .    ..       .  .
 *      .@@88:  .     .         8X8@    .     . .   .      .     .  .   SX    .   .      .      .
 *    .  8XX8;    .    .  .  . .8X8X .   . .      .   .  .    .       .88X. .      . . .    .  .  .  .
 *       ;. %  .    .       .  .;:;:.  .     .  .           .   . .  . :;      . .        .         .  .
 *    . . .  .   .   .  .             .   .    .   . . .  .               .  .      .  .    . .  .
 *         .       .      .  . .  .     .   .    .       .   . .  . .  .    .   .        .        .  .
 *    .  .    . .     .    .     .  .     .   .     .  .   .            .  .      . . .    .  . .     .
 *
 *  Copyright FortyFix(c) 2026.
 *  Title: RmaLikePlanner.ts;
 *  Path:/Volumes/Dati/SbSW_SoftwareBySystem_Works/Fortyfix/Progetti_Angular/src/environments/Modules/RmaLikePlanner.ts;
 *  Description: ;
 *  Author: Della Porta Giovanni Battista;
 *  Created at: 23/09/26, 16:01;
 *  Updated at: 23/09/26, 16:01;
 *  ```
 */

import {OggettoConfig} from "src/app/shared/_services/dynamic-crud.service";
import {CampoAggiuntivo} from "../../app/shared/models/campo-aggiuntivo";
import {Subject} from "rxjs";
import {debounceTime} from "rxjs/operators";
import {ApiPathsService} from "../../app/api-paths.service";
import {DateToDateTimeString, DateToString} from "../Utility/DateUtility";
import {FieldViewerComponent} from "../../app/shared/field-viewer/field-viewer.component";
import {Permission} from "../../app/Login/_guards/Permission";
import {
  DropdownDropdownFilterComponent, FilterList
} from "../../app/shared/dropdown-dropdown-filter/dropdown-dropdown-filter.component";
import {
  ListaInterventiOffertaComponent
} from "../../app/Interventi/lista-interventi-offerta/lista-interventi-offerta.component";
import {Injector} from "@angular/core";
import {statoResiClass} from "./Resi";


function Search(component:FieldViewerComponent, x){
  component.apiPaths.ClassicPost('/rma/interventi/list', {page: 0, size: 100, ...(x.filters ?? {})}).subscribe(data=>{
    var tasks = data.data.map(task=>{
      var out = {
        ...task,
        saveDebouncer: new Subject<any>(),
        Padre: x
      }
      out.saveDebouncer.pipe(
        debounceTime(1000),
      ).subscribe((term: any) => {
        SaveTask(term.task, term.api, x);
      });
      return out;
    });
    x.tasks = tasks;
  })

}

function Filtri(hasVistaBacheca: boolean = false){
  return [
    ...(hasVistaBacheca? [
      CampoAggiuntivo.ArrayCampiAggiuntivi([
        CampoAggiuntivo.Html("", (x)=>`
            <span class="filter-btn active first">
              <span class="filter-icon">▦</span>
              <span>Griglia</span>
            </span>
        `),
        CampoAggiuntivo.Html("", (x)=>`
            <span class="filter-btn ">
              <span class="filter-icon">⊞</span>
              <span>Bacheca</span>
            </span>
        `),

      ],'',{
        class:'filter-buttons'
      }),
      CampoAggiuntivo.Html("", (x)=>`

         <div class="filter-divider"></div>

        `, (x,permission: Permission)=>permission.isntOperativeRoles(['C']), {class:'d-flex align-items-center ml-2'}),
    ] : []),

    CampoAggiuntivo.ArrayCampiAggiuntivi([


      CampoAggiuntivo.Html("", (x)=>`
            <span class="filter-btn ${x.tutti!=false? 'active':''}">
              Tutti
            </span>
        `, ()=>true, {
        onClick:(x,component: FieldViewerComponent)=>{
          x.tutti = true;
          component.apiPaths.ClassicPost('/rma/interventi/list', {page: 0, size: 100, ...(x.filters ?? {})}).subscribe(data=>{
            var tasks = data.data.map(task=>{
              var out = {
                ...task,
                saveDebouncer: new Subject<any>()
              }
              out.saveDebouncer.pipe(
                debounceTime(1000),
              ).subscribe((term: any) => {
                SaveTask(term.task, term.api, x);
              });
              return out;
            });
            x.tasks = tasks;
          })
        }
      }),
      // CampoAggiuntivo.Html("", (x)=>`
      //       <span class="filter-btn ">
      //         Attività private
      //       </span>
      //   `),
      CampoAggiuntivo.Html("", (x)=>`
             <span class="filter-btn ${x.tutti==false? 'active':''}">
              Assegnate a me
            </span>
        `,()=>true, {
    onClick:(x,component: FieldViewerComponent)=>{
      x.tutti = false;
      component.apiPaths.ClassicPost('/rma/interventi/list', {page: 0, size: 100, responsabili:[component.authSvc.currentUserValue.id], ...(x.filters ?? {})}).subscribe(data=>{
        var tasks = data.data.map(task=>{
          var out = {
            ...task,
            saveDebouncer: new Subject<any>()
          }
          out.saveDebouncer.pipe(
            debounceTime(1000),
          ).subscribe((term: any) => {
            SaveTask(term.task, term.api, x);
          });
          return out;
        });
        x.tasks = tasks;
      })
    }
  }),

      CampoAggiuntivo.ComponentField("filter", DropdownDropdownFilterComponent,(x, component: FieldViewerComponent)=> {
        if(!x.filters)
          x.filters = {};
        return {
          FilterList:  [{
            name: 'Stato',
            Campi: x?.stati?.map(stato=>({name: stato.label, func: (option,DDCom: DropdownDropdownFilterComponent, filter: FilterList)=>{
            filter.Campi.forEach(campo=>campo.active = false);
            x.filters.stato = x.filters.stato == stato.id ? undefined : stato.id;
            option.active = x.filters.stato == stato.id;
            console.log("To Refresh", x.filters)
                Search(component, x)
          }}) ),
            onClear: (filter, DDCom: DropdownDropdownFilterComponent)=>{
              x.filters.stato = undefined;
              filter.active = false;
              filter.Campi.forEach(campo=>campo.active = false);
              Search(component, x);
            } ,
            active: false},
            {
              name: 'data',
              Campi: [
                {
                  name: 'Passato',
                  func: (option,DDCom: DropdownDropdownFilterComponent, filter: FilterList)=>{
                    filter.Campi.forEach(campo=>campo.active = false);
                    option.active = !option.active;
                   x.filters.periodo = option.active;
                   x.filters.inizio = '2020-01-01';
                   x.filters.fine = DateToString(new Date());
                   Search(component, x);
                  }
                },{
                name: 'Oggi',
                  func: (option,DDCom: DropdownDropdownFilterComponent, filter: FilterList)=>{
                    filter.Campi.forEach(campo=>campo.active = false);
                    option.active = !option.active;
                    x.filters.periodo = option.active;
                    x.filters.inizio = DateToString(new Date());
                    x.filters.fine = DateToString(new Date());

                    Search(component, x);
                  }
                }, {
                name: 'Domani',
                  func: (option,DDCom: DropdownDropdownFilterComponent, filter: FilterList)=>{
                    filter.Campi.forEach(campo=>campo.active = false);
                    const tomorrow = new Date();

                    tomorrow.setDate(tomorrow.getDate() + 1);

                    option.active = !option.active;
                    x.filters.periodo = option.active;
                    x.filters.inizio = DateToString(tomorrow);
                    x.filters.fine = DateToString(tomorrow);
                    Search(component, x);
                  }
                },
                {
                name: 'Futura',
                  func: (option,DDCom: DropdownDropdownFilterComponent, filter: FilterList)=>{
                    filter.Campi.forEach(campo=>campo.active = false);

                    option.active = !option.active;
                    x.filters.periodo = option.active;
                    x.filters.inizio = DateToString(new Date());
                    x.filters.fine = '2100-01-01';
                    Search(component, x);
                  }
                }
              ],
              onClear: (filter, DDCom: DropdownDropdownFilterComponent)=>{
                x.filters.inizio = undefined;
                x.filters.fine = undefined;
                x.filters.dataFsel = undefined;
                x.periodo = false;
                filter.active = false;
                filter.Campi.forEach(campo=>campo.active = false);
                Search(component, x);
              } ,
            }

          ]
        }
      },(x)=>x.stati?.length, {refreshInjector:true, class: ''} )
    ],'',{
      class:'filter-buttons',
      hideif:{func: (x,permission: Permission)=>permission.isntOperativeRoles(['C', 'OP'])}
    }),

  ]
}

function SaveTask(task, api:ApiPathsService, TaskPadre){
  console.log("Task To Save", task);
  if(!task.nome) return;
  var tosave = {...task};
  delete tosave.saveDebouncer;
  api.ClassicPost(`/rma/interventi/${task.id ? 'update': 'add'}`, tosave).subscribe(data=>{
    if(!task.id){
      var idx = TaskPadre.tasks.findIndex(x=>x.virtualid==task.virtualid);
      TaskPadre.tasks[idx].id = data.id;
    }

    console.log("Task Saved", data);
  })
}


function CampoChangeFunc(x, selected, api,toast){
  x.saveDebouncer.next({task: x, api});
}

function RmaLikePlanner() {
  var OBJ: OggettoConfig = {
    Id: "rmaplanner",
    EditView: 'Page',
    NoSaveAdd:true,
    asyncMap:(x, component,callback)=>{

      component.api.ClassicPost('/rma/interventi/list', {page: 0, size: 100}).subscribe(data=>{
        var tasks = data.data.map(task=>{
          var out = {
            ...task,
            saveDebouncer: new Subject<any>()
          }
          out.saveDebouncer.pipe(
            debounceTime(1000),
          ).subscribe((term: any) => {
            SaveTask(term.task, term.api, x);
          });
          return out;
        });

        var stati = [];
        component.api.ClassicGet('/rma/interventi/stati').subscribe(data=>{
          stati = data
        callback({tasks, stati});
        })
        });

    },
    campi:[
      ...Filtri(),
      CampoAggiuntivo.TableField("", [
        CampoAggiuntivo.TextField("Nome Attività", "nome", 'col-lg-12', {
          modificabile: true,
          OnChangeFunc: CampoChangeFunc
        }),
        CampoAggiuntivo.InputField("In scadenza", "data_fine_prevista", 'datetime-local','col-lg-12', {
          modificabile: true,
          OnChangeFunc: CampoChangeFunc
        }),

        CampoAggiuntivo.ArrayCampiAggiuntivi([
          CampoAggiuntivo.SingleDropdown("", 'cliente', '/anagrafica/clienti/list', 'nominativo', {
            OnChangeFunc: CampoChangeFunc,
            placeholder: "Seleziona il cliente",
            responseHasData:true,
            hideLabel:true,
            hideif:{func: (x,permission: Permission)=>permission.isntOperativeRoles(['C'])},
            parameter: [{ nome: "page", value: 1 }, { nome: "size", value: 200 },
              {
                nome: "ruolo",
                value: 'C'
              },
              { nome: "nome", search: true }
            ]
          },'col-lg-12 mt-0',(x,permission: Permission)=>permission.isntOperativeRoles(['C']), {
            allowRemoteDataSearch:true,
            searchPlaceholderText:'Cerca'
          }),
          CampoAggiuntivo.Html("", (x)=> x.clienteObject?.nominativo, (x,permission: Permission)=>permission.isOperativeRoles(['C']))
          // CampoAggiuntivo.TextField("cliente", 'clienteObject.nominativo', 'col-12',{
          //   hideif:{func: (x,permission: Permission)=>permission.isOperativeRoles(['C'])},
          //   modificabile:false,
          // }),
        ],"Clienti"),

        CampoAggiuntivo.ArrayCampiAggiuntivi([
          CampoAggiuntivo.SingleDropdown("", 'manager', '/anagrafica/persone/list', 'fullName', {
            OnChangeFunc: CampoChangeFunc,
            hideLabel:true,
            placeholder: "Seleziona il responsabile",
            responseHasData:true,
            hideif:{func: (x,permission: Permission)=>permission.isntOperativeRoles(['C'])},
            parameter: [
              { nome: "page", value: 1 },
              { nome: "size", value: 200 },
              { nome: "nome", search: true }
            ]
          },'col-lg-12',()=>true, {
            allowRemoteDataSearch:true,
            searchPlaceholderText:'Cerca'
          }),
          CampoAggiuntivo.Html("", (x)=> x.managerObject?.fullName, (x,permission: Permission)=>permission.isOperativeRoles(['C']))
          // CampoAggiuntivo.TextField("cliente", 'clienteObject.nominativo', 'col-12',{
          //   hideif:{func: (x,permission: Permission)=>permission.isOperativeRoles(['C'])},
          //   modificabile:false,
          // }),
        ],"Responsabile"),




        CampoAggiuntivo.SingleDropdown("Stato", 'stato', '/rma/interventi/stati', 'label', {
          OnChangeFunc: CampoChangeFunc
        },'col-lg-12'),
        CampoAggiuntivo.Html("Visualizza", (x)=>`
          <a class="btn btn-primary" href="/rma/interventi/${x.id}"><i class="fas fa-eye"></i></a>
        `, (x)=>true, {
          onClick: (task, component: FieldViewerComponent)=>{
            component.taskService.OpenFromTask(task, (ts)=>{
              Object.getOwnPropertyNames(ts).forEach(key=>task[key] = ts[key])
            })
          }
        })
      ],'tasks', true),
      CampoAggiuntivo.Html("", (x)=>`
        <span class="add-btn">Aggiungi nuova attività</span>
      `, (x)=>!x.tasks?.some(x=>x.nome==""), {
        class:'d-flex align-items-center ml-2',
        onClick:(x, component: FieldViewerComponent)=>{
          var out = {
            nome: "",
            virtualid: x.tasks?.reduce((max, item) => Math.max(max, Number(item.virtualid) || 0), 0),
            data_inizio_prevista: DateToDateTimeString(new Date()),
            alert_inizio_task:0,
            alert_fine_task:0,
            type: 'R',
            cliente: component.permission.isOperativeRoles(['C']) ? component.authSvc.currentUserValue.id : null,
            clienteObject: component.permission.isOperativeRoles(['C']) ? {id: component.authSvc.currentUserValue.id, nominativo: component.authSvc.currentUserValue.fullName} : null,
            saveDebouncer: new Subject<any>()
          }
          out.saveDebouncer.pipe(
            debounceTime(1000),
          ).subscribe((term: any) => {
            SaveTask(term.task, term.api, x);
          });
          x.tasks?.push(out)
        }
      })
    ],
    NoSaveEdit:true,
    MenuItems: [
      {
        path: "/shared/dynamicedit/rmaplanner",
        title: "Attività esterne",
        icon: "fas fa-bilding",
        class: "",
        capacita: ['gestione-rma'],
      },
    ]
  }
  return OBJ;
}


export var RmaLikePlannerEnv = () => {
  var env: any = {
    Modules: {
      "RmaLikePlanner": true,
      Dashboard: true
    },
    homepages: [
       {Ruoli: ["C"], link: "/shared/dynamicedit/rmaplanner"}
    ],
    Cruds: [RmaLikePlanner()],
    Menu: [...RmaLikePlanner().MenuItems]
  }
  return env;

}
